/* eslint-disable no-restricted-syntax */
import axios from 'axios'

import {
    UPDATE_MESSAGE_START,
    UPDATE_MESSAGE_SUCCESS,
    UPDATE_MESSAGE_FAIL,
} from './constants'

import { OPERATOR_MESSAGE_SUBMIT } from '../../constants'

export default (newMessageObject, doNotSend = false) => dispatch => {
    dispatch({
        type: UPDATE_MESSAGE_START,
    })

    const key = `${newMessageObject.AccountId}/${newMessageObject.ThreadId}/${newMessageObject.UserId}`

    let expriningConvosArray = sessionStorage.getItem(
        'pulsarBotPlatform_operatorExpiringConvos'
    )

    if (expriningConvosArray) {
        expriningConvosArray = JSON.parse(expriningConvosArray)
        if (expriningConvosArray.includes(key)) {
            expriningConvosArray.pop(key)

            sessionStorage.setItem(
                'pulsarBotPlatform_operatorExpiringConvos',
                JSON.stringify(expriningConvosArray)
            )
        }
    }

    const headers = {
        'Content-Type': 'application/json',
    }

    if (doNotSend) {
        headers['X-Not-Send'] = 'Yes'
    }

    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )

    headers.authorization = authorization

    axios({
        url: '/api/operators/message',
        method: 'put',
        headers,
        data: { newMessageObject },
    })
        .then(res => {
            dispatch({
                type: UPDATE_MESSAGE_SUCCESS,
                payload: newMessageObject.MessageId,
            })

            const successfullySentMessages = res.data || []

            for (const message of successfullySentMessages) {
                dispatch({
                    type: OPERATOR_MESSAGE_SUBMIT,
                    payload: { message, doNotSend },
                })
            }
        })
        .catch(err => {
            // eslint-disable-next-line no-console
            console.log(err)

            dispatch({
                type: UPDATE_MESSAGE_FAIL,
            })
        })
}
